<template>
  <div class="card shadow" id="errosGerais" ref="errosGerais">
    <div class="card-header" ref="homePage">
      <h3 class="card-title" v-if="this.add">
        <img src="media/icons/duotune/general/gen055.svg" class="me-2" />Enviar
        Ticket
      </h3>
      <div class="card-title" v-else-if="this.ticket.id > 0">
        <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
          <inline-svg src="media/icons/duotune/communication/com007.svg" />
        </span>
        <h2 class="fw-semibold me-3 my-4">{{ this.ticket.assunto }}</h2>
        <span
          :class="[
            this.ticket.situacao
              ? this.getSituacaoColor(this.ticket.situacao)
              : '',
          ]"
          >{{ this.ticket.situacao }}</span
        >
        <span
          v-if="this.ticket.prioridade === `1`"
          :class="[
            this.ticket.prioridade === `1`
              ? `badge badge-light-danger text-danger fw-bold fs-7 my-1 ms-2`
              : '',
          ]"
          >Importante</span
        >
      </div>
      <div class="card-toolbar">
        <router-link
          to="/suporte/ticket/consultar"
          class="btn btn-sm btn-light"
        >
          <span class="svg-icon svg-icon-1">
            <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
          </span>
          Voltar
        </router-link>
      </div>
    </div>
    <div class="card-body pt-2">
      <div
        v-if="loading"
        class="ms-7 mb-7 mt-4"
        v-bind:data-kt-indicator="loading ? 'on' : 'off'"
      >
        <span class="indicator-progress">
          Aguarde, carregando...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </div>
      <div
        v-if="this.errosGerais.Message"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 mt-6 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              {{ this.errosGerais.Message }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading">
        <div v-if="this.add === false" class="row">
          <div class="col-12 mb-4">
            <div
              v-for="(mensagem, i) in this.ticket.TicketMensagem"
              v-bind:key="i"
            >
              <div
                v-if="mensagem.id > 0"
                :ref="`ticket_mensagem${i}`"
                class="card-header mt-0 ps-0 pt-6 pb-2 collapsible border-0 collapsed"
                role="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#ticket_mensagem${i}`"
                aria-expanded="false"
                :aria-controls="`ticket_mensagem${i}`"
                @click="mensagem.expandida = mensagem.expandida ? false : true"
              >
                <div class="d-flex flex-row text-gray-900">
                  <div
                    v-if="
                      mensagem.Usuario &&
                      mensagem.Usuario.UsuarioDado &&
                      mensagem.Usuario.UsuarioDado.foto
                        ? mensagem.Usuario.UsuarioDado.foto
                        : ''
                    "
                    class="symbol symbol-50px me-4"
                  >
                    <div
                      class="symbol-label fs-2 fw-bold bg-light-dark"
                      :style="{
                        'background-image': `url(${
                          this.$utils.getUrl() +
                          mensagem.Usuario.UsuarioDado.foto
                        })`,
                      }"
                    ></div>
                  </div>
                  <div v-else class="symbol symbol-50px me-4">
                    <div
                      :class="[
                        'symbol-label fs-2 fw-bold ' +
                          this.$utils.getColorRandom(),
                      ]"
                    >
                      {{
                        mensagem.Usuario && mensagem.Usuario.nome
                          ? mensagem.Usuario.nome.substring(0, 1).toUpperCase()
                          : ""
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-row align-items-center">
                      <div
                        class="text-dark text-hover-primary fw-bold fs-6 me-4"
                      >
                        {{
                          mensagem.Usuario && mensagem.Usuario.nome
                            ? mensagem.Usuario.nome
                            : ""
                        }}
                      </div>
                      <span class="svg-icon svg-icon-3 svg-icon-success me-4">
                        <inline-svg
                          src="media/icons/duotune/coding/cod005.svg"
                        />
                      </span>
                      <div class="text-muted fw-semibold fs-7">
                        {{
                          this.$utils.formatarDataCustomizadaFusoHorario(
                            mensagem.updatedAt
                          )
                        }}
                      </div>
                    </div>
                    <div
                      v-if="!mensagem.expandida"
                      class="text-muted fw-semibold mw-450px"
                      style="
                        max-height: 2.6em;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        line-height: 1.3em;
                      "
                    >
                      {{ this.extrairTexto(mensagem.mensagem) }}
                    </div>
                    <div v-else class="text-muted fw-semibold">
                      {{
                        mensagem.Usuario && mensagem.Usuario.usuario
                          ? mensagem.Usuario.usuario
                          : ""
                      }}
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-row align-items-center mt-4"
                  v-if="mensagem.expandida"
                >
                  <div class="text-muted fw-semibold">
                    {{
                      this.$utils.formatarDataHoraCustomizadaFusoHorario(
                        mensagem.updatedAt
                      )
                    }}
                  </div>
                  <button
                    v-if="
                      this.editar &&
                      this.user.User.id_empresa === mensagem.Usuario.id_empresa
                    "
                    type="button"
                    class="btn btn-sm btn-icon btn-clear btn-active-light-primary ms-3"
                    @click="editarTicketMensagem(i)"
                  >
                    <span class="svg-icon svg-icon-1">
                      <inline-svg src="media/icons/duotune/art/art005.svg"
                    /></span>
                  </button>
                  <button
                    v-if="
                      this.excluir &&
                      this.user.User.id_empresa === mensagem.Usuario.id_empresa
                    "
                    type="button"
                    class="btn btn-sm btn-icon btn-clear btn-active-light-danger ms-1"
                    @click="excluirTicketMensagem(i)"
                  >
                    <span class="svg-icon svg-icon-1">
                      <inline-svg src="media/icons/duotune/general/gen027.svg"
                    /></span>
                  </button>
                </div>
                <div class="card-toolbar rotate-180">
                  <span class="svg-icon svg-icon-1"
                    ><inline-svg src="media/icons/duotune/arrows/arr082.svg"
                  /></span>
                </div>
              </div>
              <div
                v-if="mensagem.id > 0 && !mensagem.expandida"
                class="d-flex flex-row align-items-center mb-5"
              >
                <div class="mt-0 mb-0 text-muted fw-semibold">
                  {{
                    this.$utils.formatarDataHoraCustomizadaFusoHorario(
                      mensagem.updatedAt
                    )
                  }}
                </div>
                <button
                  v-if="
                    this.editar &&
                    this.user.User.id_empresa === mensagem.Usuario.id_empresa
                  "
                  type="button"
                  class="btn btn-sm btn-icon btn-clear btn-active-light-primary ms-3"
                  @click="editarTicketMensagem(i)"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg src="media/icons/duotune/art/art005.svg"
                  /></span>
                </button>
                <button
                  v-if="
                    this.excluir &&
                    this.user.User.id_empresa === mensagem.Usuario.id_empresa
                  "
                  type="button"
                  class="btn btn-sm btn-icon btn-clear btn-active-light-danger ms-1"
                  @click="excluirTicketMensagem(i)"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg src="media/icons/duotune/general/gen027.svg"
                  /></span>
                </button>
              </div>
              <div
                v-if="mensagem.id > 0"
                :id="`ticket_mensagem${i}`"
                class="collapse mt-4 mb-6 p-6 col-12 border rounded"
              >
                <div
                  :id="`htmlConteudo${i}`"
                  class="ck-content message-box"
                  v-html="mensagem.mensagem"
                ></div>
              </div>
              <div
                v-if="
                  mensagem.id > 0 && i < this.ticket.TicketMensagem.length - 1
                "
                class="separator"
              ></div>
            </div>
          </div>
        </div>
        <div :id="`id_ckeditor`" :ref="`id_ckeditor`" tabindex="0" class="row">
          <div
            v-if="this.add"
            class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-7 mb-4 mt-6"
          >
            <div class="fv-row">
              <label class="form-label">Assunto</label>
              <input
                id="txtAssunto"
                type="text"
                class="form-control mb-2"
                v-model="ticket.assunto"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao[`assunto`] }}
              </div>
            </div>
          </div>
          <div
            v-if="this.add || this.user.User.TipoUsuario.tipo !== 'Usuário'"
            class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-4 mt-6"
          >
            <div class="d-flex flex-column fv-row">
              <label class="form-label">Prioridade</label>
              <div
                class="btn btn-icon w-40px h-40px"
                :class="[
                  ticket.prioridade === `1`
                    ? `btn-color-primary`
                    : `btn-color-gray-500`,
                ]"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Importante"
                @click="
                  (ticket.prioridade = ticket.prioridade === `0` ? `1` : `0`),
                    this.atualizarTicket()
                "
              >
                <span class="svg-icon svg-icon-1 svg-icon lh-0">
                  <inline-svg src="media/icons/duotune/general/gen056.svg" />
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="this.user.User.TipoUsuario.tipo !== 'Usuário'"
            class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-5 col-xxl-3 mb-4 mt-6"
          >
            <div class="fv-row">
              <label class="form-label">Situação</label>
              <select
                class="form-select mb-0"
                data-placeholder="Selecione uma opção"
                v-model="ticket.situacao"
                :readonly="
                  this.user.User.TipoUsuario.tipo === 'Usuário' ? true : false
                "
                :disabled="
                  this.user.User.TipoUsuario.tipo === 'Usuário' ? true : false
                "
                @change="this.atualizarTicket()"
              >
                <option value="Pendente">Pendente</option>
                <option value="Em Andamento">Em Andamento</option>
                <option value="Finalizado">Finalizado</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao[`situacao`] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="fv-row">
              <ckeditor
                :editor="editor"
                v-model="editorData"
                :config="editorConfig"
              ></ckeditor>
              <div class="fv-plugins-message-container invalid-feedback">
                {{
                  errosValidacao[`mensagem`] ||
                  errosValidacao[`TicketMensagem[0]mensagem`]
                }}
              </div>
              <button
                v-if="this.add === false"
                class="btn btn-primary svg-icon-white me-2 mb-2 mt-2 h-45px"
                @click="confirmarTicketMensagem()"
                v-bind:data-kt-indicator="loadingTicketMensagem ? 'on' : 'off'"
              >
                <span class="indicator-progress">
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-1"
                  ></span>
                  Aguarde...
                </span>
                <span class="svg-icon svg-icon-1" v-if="!loadingTicketMensagem">
                  <inline-svg
                    src="media/icons/duotune/communication/com003.svg"
                    class="me-2"
                  />Enviar
                </span>
              </button>
              <button
                v-if="
                  this.add === false &&
                  this.indexEdicao != -1 &&
                  this.ticket.TicketMensagem[this.indexEdicao].id > 0
                "
                class="btn btn-active-secondary svg-icon-white me-2 mb-2 mt-2 h-45px"
                @click="cancelarTicketMensagem()"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.add" class="card-footer">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4">
        <button
          class="btn btn-primary svg-icon-white me-2 mb-2"
          @click="adicionarTicket()"
          v-bind:data-kt-indicator="loading ? 'on' : 'off'"
        >
          <span class="indicator-progress">
            <span
              class="spinner-border spinner-border-sm align-middle ms-1"
            ></span>
            Aguarde...
          </span>
          <span class="svg-icon svg-icon-1" v-if="!loading">
            <inline-svg
              src="media/icons/duotune/communication/com003.svg"
              class="me-2"
            />Enviar
          </span>
        </button>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalTicketMensagem'"
    mensagem=""
    v-if="this.loadingTicketMensagem === true"
  ></LoadingModal>
</template>

<script>
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { ClassicEditor } from "@ckeditor/ckeditor5-editor-classic";

import { Alignment } from "@ckeditor/ckeditor5-alignment";
import { Autoformat } from "@ckeditor/ckeditor5-autoformat";
import {
  Bold,
  Italic,
  Strikethrough,
  Subscript,
  Superscript,
  Underline,
} from "@ckeditor/ckeditor5-basic-styles";
import { BlockQuote } from "@ckeditor/ckeditor5-block-quote";
import { CodeBlock } from "@ckeditor/ckeditor5-code-block";
import { Essentials } from "@ckeditor/ckeditor5-essentials";
import { FindAndReplace } from "@ckeditor/ckeditor5-find-and-replace";
import {
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
} from "@ckeditor/ckeditor5-font";
import { Heading } from "@ckeditor/ckeditor5-heading";
import { Highlight } from "@ckeditor/ckeditor5-highlight";
import { HorizontalLine } from "@ckeditor/ckeditor5-horizontal-line";
import { HtmlEmbed } from "@ckeditor/ckeditor5-html-embed";
import {
  DataFilter,
  DataSchema,
  GeneralHtmlSupport,
  HtmlComment,
} from "@ckeditor/ckeditor5-html-support";
import {
  AutoImage,
  Image,
  ImageCaption,
  ImageInsert,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  PictureEditing,
} from "@ckeditor/ckeditor5-image";
import { Indent, IndentBlock } from "@ckeditor/ckeditor5-indent";
import { AutoLink, Link, LinkImage } from "@ckeditor/ckeditor5-link";
import { List, ListProperties, TodoList } from "@ckeditor/ckeditor5-list";
import {
  MediaEmbed,
  MediaEmbedToolbar,
  AutoMediaEmbed,
} from "@ckeditor/ckeditor5-media-embed";
import { Mention } from "@ckeditor/ckeditor5-mention";
import { PageBreak } from "@ckeditor/ckeditor5-page-break";
import { Paragraph } from "@ckeditor/ckeditor5-paragraph";
import { PasteFromOffice } from "@ckeditor/ckeditor5-paste-from-office";
import { RemoveFormat } from "@ckeditor/ckeditor5-remove-format";
import { SelectAll } from "@ckeditor/ckeditor5-select-all";
import { ShowBlocks } from "@ckeditor/ckeditor5-show-blocks";
import { SourceEditing } from "@ckeditor/ckeditor5-source-editing";
import {
  SpecialCharacters,
  SpecialCharactersArrows,
  SpecialCharactersCurrency,
  SpecialCharactersEssentials,
  SpecialCharactersLatin,
  SpecialCharactersMathematical,
  SpecialCharactersText,
} from "@ckeditor/ckeditor5-special-characters";
import {
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
} from "@ckeditor/ckeditor5-table";
import { TextTransformation } from "@ckeditor/ckeditor5-typing";
import { Undo } from "@ckeditor/ckeditor5-undo";
import ImageRemoveEventCallbackPlugin from "ckeditor5-image-remove-event-callback-plugin";
import UploadAdapter from "@/utils/UploadAdapter";
import { useToast } from "vue-toastification";
const toast = useToast();
import { mapState } from "vuex";
import { hideModalId, getOrCreateInstanceModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import $bus from "@/utils/event.js";

const ticketInicializado = {
  id: 0,
  assunto: "",
  prioridade: "0",
  situacao: "Pendente",
  id_empresa: 0,
  id_revenda: 0,
  id_usuario: 0,
  TicketMensagem: [
    {
      id: 0,
      id_ticket: 0,
      mensagem: "",
      id_usuario: 0,
      imagemRemover: [],
    },
  ],
};

function uploader(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new UploadAdapter(loader);
  };
}

export default {
  components: { LoadingModal },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async atualizarTicket() {
      if (this.ticket.id > 0) {
        await this.exibirModalLoadingTicketMensagem(true);
        var formData = this.$utils.convertModelToFormData(this.ticket);
        try {
          var ret = await this.$store.dispatch("ticket/putTicket", formData);
          if (ret.Success === true) {
            toast.success("Ticket atualizado com sucesso!", {
              timeout: 3000,
            });
          }
        } catch (error) {
          this.errosGerais = error;
          this.errosValidacao = error;
        }
        await this.exibirModalLoadingTicketMensagem(false);
      }
    },
    async exibirModalLoadingTicketMensagem(exibir, callback) {
      if (exibir === true) {
        this.loadingTicketMensagem = true;
        getOrCreateInstanceModal(
          "loadingModalTicketMensagem",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalTicketMensagem", () => {
          this.loadingTicketMensagem = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
        });
      }
    },
    scrollIndex(refName) {
      let el = this.$refs[refName];
      if (el) {
        el[0].scrollIntoView({
          behavior: "smooth",
        });
      }
    },
    getSituacaoColor(situacao) {
      if (situacao.toUpperCase() === "FINALIZADO") {
        return "badge badge-success";
      } else if (situacao.toUpperCase() === "EM ANDAMENTO") {
        return "badge badge-info";
      } else if (situacao.toUpperCase() === "PENDENTE") {
        return "badge badge-primary";
      } else {
        return "badge badge-dark";
      }
    },
    cancelarTicketMensagem() {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.indexEdicao = -1;
      this.editorData = "";
    },
    async confirmarTicketMensagem() {
      await this.exibirModalLoadingTicketMensagem(true);
      this.errosGerais = {};
      this.errosValidacao = [];

      if (this.indexEdicao === -1) {
        this.ticket.TicketMensagem.push(
          JSON.parse(JSON.stringify(ticketInicializado.TicketMensagem[0]))
        );
        this.indexEdicao = this.ticket.TicketMensagem.length - 1;
        this.ticket.TicketMensagem[this.indexEdicao].id_ticket = this.ticket.id;
        this.ticket.TicketMensagem[this.indexEdicao].id_usuario =
          this.user.User.id;
      }

      const blobsTemporarios = this.encontrarURLsBlob(this.editorData);
      const formFiles = await this.converterBlobsParaFormFiles(
        blobsTemporarios
      );

      if (formFiles.length > 0) {
        await this.uploadFormFiles(formFiles);
      }

      if (this.imagensRemover.length > 0) {
        for (var imagem of this.imagensRemover) {
          if (!this.editorData.includes(imagem)) {
            if (imagem.includes("blob")) {
              URL.revokeObjectURL(imagem);
            } else {
              if (
                this.ticket.TicketMensagem[this.indexEdicao].imagemRemover ===
                undefined
              ) {
                this.ticket.TicketMensagem[this.indexEdicao].imagemRemover = [];
              }
              this.ticket.TicketMensagem[this.indexEdicao].imagemRemover.push(
                imagem.replace(this.$utils.getUrl(), "")
              );
            }
          }
        }
      }

      this.ticket.TicketMensagem[this.indexEdicao].mensagem = this.editorData;
      this.ticket.TicketMensagem[this.indexEdicao].mensagem =
        this.ticket.TicketMensagem[this.indexEdicao].mensagem.replace(
          new RegExp(this.$utils.getUrl(), "g"),
          ""
        );

      var formData = this.$utils.convertModelToFormData(
        this.ticket.TicketMensagem[this.indexEdicao]
      );
      if (this.ticket.TicketMensagem[this.indexEdicao].id === 0) {
        try {
          var ret = await this.$store.dispatch(
            "ticketMensagem/postTicketMensagem",
            formData
          );
          if (ret.Success === true) {
            toast.success("Mensagem enviada com sucesso!", {
              timeout: 3000,
            });
            await this.carregarTicket();
            this.scrollMensagem(this.indexEdicao);
          }
        } catch (error) {
          this.errosGerais = error;
          this.errosValidacao = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch(
            "ticketMensagem/putTicketMensagem",
            formData
          );
          if (retPut.Success === true) {
            toast.success("Mensagem atualizada com sucesso!", {
              timeout: 3000,
            });
            await this.carregarTicket();
            this.scrollMensagem(this.indexEdicao);
          }
        } catch (error) {
          this.errosGerais = error;
          this.errosValidacao = error;
        }
      }

      await this.exibirModalLoadingTicketMensagem(false);
    },
    scrollMensagem(index) {
      this.editorData = "";
      this.indexEdicao = -1;

      // if (index > 0) {
      //   setTimeout(() => {
      //     this.scrollIndex("ticket_mensagem" + (index - 1));
      //   }, 500);
      // } else {
      setTimeout(() => {
        this.scroll("homePage");
      }, 500);
      //}
    },
    async editarTicketMensagem(index) {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.indexEdicao = index;
      this.editorData = this.ticket.TicketMensagem[this.indexEdicao].mensagem;
      this.scroll("id_ckeditor");
    },
    async excluirTicketMensagem(index) {
      await this.$swal.showQuestionAlert(
        "Deseja remover esta mensagem?",
        async (alert) => {
          if (alert.isConfirmed) {
            await this.exibirModalLoadingTicketMensagem(true);
            this.errosValidacaoGeral = [];
            try {
              var ret = await this.$store.dispatch(
                "ticketMensagem/deleteTicketMensagem",
                this.ticket.TicketMensagem[index].id
              );
              if (ret.Success === true) {
                toast.success("Mensagem excluída com sucesso!", {
                  timeout: 3000,
                });
                await this.carregarTicket();
              }
            } catch (error) {
              this.errosValidacaoGeral.push(error.Message);
            }
            await this.exibirModalLoadingTicketMensagem(false);
          }
        }
      );
    },
    extrairTexto(html) {
      let texto = this.decodificarHTML(html);
      return texto.split("\n").slice(0, 2).join(" ");
    },
    decodificarHTML(htmlString) {
      const tempElement = document.createElement("div");
      tempElement.innerHTML = htmlString;
      return tempElement.textContent || tempElement.innerText;
    },
    removerImagems(images) {
      for (const element of images) {
        if (element != undefined && element != null && element != "") {
          this.imagensRemover.push(element);
        }
      }
    },
    async adicionarTicket() {
      this.loading = true;
      this.errosGerais = {};
      this.errosValidacao = [];

      const blobsTemporarios = this.encontrarURLsBlob(this.editorData);
      const formFiles = await this.converterBlobsParaFormFiles(
        blobsTemporarios
      );

      if (formFiles.length > 0) {
        await this.uploadFormFiles(formFiles);
      }

      if (this.imagensRemover.length > 0) {
        for (var imagem of this.imagensRemover) {
          if (!this.editorData.includes(imagem)) {
            if (imagem.includes("blob")) {
              URL.revokeObjectURL(imagem);
            } else {
              if (this.ticket.TicketMensagem[0].imagemRemover === undefined) {
                this.ticket.TicketMensagem[0].imagemRemover = [];
              }
              this.ticket.TicketMensagem[0].imagemRemover.push(
                imagem.replace(this.$utils.getUrl(), "")
              );
            }
          }
        }
      }

      this.ticket.TicketMensagem[0].mensagem = this.editorData;
      this.ticket.TicketMensagem[0].mensagem =
        this.ticket.TicketMensagem[0].mensagem.replace(
          new RegExp(this.$utils.getUrl(), "g"),
          ""
        );

      this.ticket.id_empresa = this.user.User.Emitente.id;
      this.ticket.id_revenda = this.user.User.Emitente.Revenda.id;
      this.ticket.id_usuario = this.user.User.id;

      this.ticket.TicketMensagem[0].id_usuario = this.user.User.id;

      var formData = this.$utils.convertModelToFormData(this.ticket);
      try {
        var ret = await this.$store.dispatch("ticket/postTicket", formData);
        if (ret.Success === true) {
          toast.success("Ticket cadastrado com sucesso!", {
            timeout: 3000,
          });
          this.$router.push("/suporte/ticket/consultar");
        }
      } catch (error) {
        this.errosGerais = error;
        this.errosValidacao = error;
      }

      this.loading = false;
    },
    async uploadFormFiles(formFiles) {
      const uploads = {
        ticketMensagemUploadViewModel: formFiles.map((formFile) => ({
          imagem: "",
          formFile: formFile,
        })),
      };
      const formData = this.$utils.convertModelToFormData(uploads);
      try {
        var ret = await this.$store.dispatch(
          "ticketMensagem/postTicketMensagemUpload",
          formData
        );
        if (ret.Success === true) {
          const urls = ret.Data;
          urls.forEach((url) => {
            const imagem = this.$utils.getUrl() + url.imagem;
            this.editorData = this.editorData.replace(
              new RegExp(url.formFile.FileName, "g"),
              imagem
            );
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    encontrarURLsBlob(html) {
      const blobRegex = /blob:[^'"]+/g;
      const matches = html.match(blobRegex);
      return matches ? matches : [];
    },
    async converterBlobsParaFormFiles(blobs) {
      const formFiles = [];

      for (const blobURL of blobs) {
        const blob = await this.blobURLParaBlob(blobURL);
        const formFile = this.blobParaFormFile(blob, blobURL);
        formFiles.push(formFile);
      }

      return formFiles;
    },
    blobURLParaBlob(blobURL) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", blobURL, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
          resolve(xhr.response);
        };
        xhr.send();
      });
    },
    blobParaFormFile(blob, name) {
      const formFile = new File([blob], name, { type: "image/png" });
      return formFile;
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async limparTicket() {
      this.ticket = JSON.parse(JSON.stringify(ticketInicializado));

      this.errosGerais = {};
      this.errosValidacao = [];
      this.imagensRemover = [];
      this.editorData = "";
      this.indexEdicao = -1;
    },
    async carregarTicket() {
      var id = this.$route.params.id;
      try {
        var ret = await this.$store.dispatch(
          "ticket/getTicketOData",
          "?$expand=TicketMensagem($expand=Usuario($expand=UsuarioDado);$orderby=updatedAt desc)&$filter=id eq " +
            id
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.ticket = ret.value[0];

          if (this.ticket.TicketMensagem != null) {
            for (const mensagem of this.ticket.TicketMensagem) {
              mensagem.mensagem = mensagem.mensagem.replace(
                new RegExp("/uploads/Ticket", "g"),
                this.$utils.getUrl() + "/uploads/Ticket"
              );
            }
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
      this.loading = false;
    },
    async asyncData() {
      if (this.$route.params.id !== undefined) {
        this.loading = true;
        this.add = false;
        await this.carregarTicket();
      } else {
        this.add = true;
        this.limparTicket();
        setTimeout(() => {
          this.nextFocus("txtAssunto");
        }, 800);
      }

      this.indexEdicao = -1;
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Ticket.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.Ticket.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
  },
  watch: {
    $route: {
      handler: "asyncData",
      immediate: true,
    },
  },
  unmounted() {
    $bus.off("atualizar-ticket");
  },
  async mounted() {
    await this.verificarRestricoes();
    this.asyncData();

    $bus.on("atualizar-ticket", async () => {
      this.loading = true;
      await this.carregarTicket();
      this.scrollMensagem(0);
    });
  },
  data() {
    return {
      loadingTicketMensagem: false,
      indexEdicao: -1,
      timeOut: null,
      add: false,
      editar: false,
      excluir: false,
      loading: false,
      errosGerais: {},
      errosValidacao: [],
      imagensRemover: [],
      ticket: JSON.parse(JSON.stringify(ticketInicializado)),
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        language: "pt-br",
        extraPlugins: [uploader],
        plugins: [
          Alignment,
          AutoImage,
          AutoMediaEmbed,
          AutoLink,
          Autoformat,
          BlockQuote,
          Bold,
          CodeBlock,
          DataFilter,
          DataSchema,
          Essentials,
          FindAndReplace,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          GeneralHtmlSupport,
          Heading,
          Highlight,
          HorizontalLine,
          HtmlComment,
          HtmlEmbed,
          Image,
          ImageCaption,
          ImageInsert,
          ImageResize,
          ImageStyle,
          ImageToolbar,
          Indent,
          IndentBlock,
          Italic,
          Link,
          LinkImage,
          List,
          ListProperties,
          MediaEmbed,
          MediaEmbedToolbar,
          Mention,
          PageBreak,
          Paragraph,
          PasteFromOffice,
          PictureEditing,
          RemoveFormat,
          SelectAll,
          ShowBlocks,
          SourceEditing,
          SpecialCharacters,
          SpecialCharactersArrows,
          SpecialCharactersCurrency,
          SpecialCharactersEssentials,
          SpecialCharactersLatin,
          SpecialCharactersMathematical,
          SpecialCharactersText,
          Strikethrough,
          Subscript,
          Superscript,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar,
          TextTransformation,
          TodoList,
          Underline,
          Undo,
          ImageRemoveEventCallbackPlugin,
        ],
        toolbar: {
          items: [
            "undo",
            "redo",
            "|",
            "heading",
            "|",
            "fontFamily",
            "fontSize",
            "fontColor",
            "fontBackgroundColor",
            "highlight",
            "removeFormat",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "subscript",
            "superscript",
            "specialCharacters",
            "|",
            "alignment",
            "outdent",
            "indent",
            "|",
            "bulletedList",
            "numberedList",
            "todoList",
            "|",
            "link",
            "imageInsert",
            "mediaEmbed",
            "insertTable",
            "blockQuote",
            "codeBlock",
            "htmlEmbed",
            "|",
            "horizontalLine",
            "pageBreak",
            "|",
            "findAndReplace",
            "selectAll",
            "showBlocks",
            "sourceEditing",
          ],
        },
        image: {
          toolbar: [
            "imageTextAlternative",
            "toggleImageCaption",
            "imageStyle:inline",
            "imageStyle:block",
            "imageStyle:side",
            "linkImage",
          ],
        },
        table: {
          contentToolbar: [
            "tableColumn",
            "tableRow",
            "mergeTableCells",
            "tableCellProperties",
            "tableProperties",
          ],
        },
        imageRemoveEvent: {
          additionalElementTypes: null,
          callback: (imagesSrc, nodeObjects) => {
            this.removerImagems(imagesSrc);
          },
        },
        mediaEmbed: {
          previewsInData: true,
        },
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true,
            },
          ],
        },
      },
    };
  },
};
</script>

<style>
code {
  font-size: inherit !important;
  color: var(--kt-code-color) !important;
  text-shadow: none !important;
  font-family: var(--bs-font-monospace) !important;
}
.imagePreviewWrapper {
  background-size: contain !important;
  background-position: center !important;
}
.message-box {
  min-height: 50px !important;
}
</style>
